const predefinedNames = [
    "Adjei, Larissa", 
    "Aggarwal, Krishiv", 
    "Ayiih, Justin", 
    "Baro, Harrison", 
    "Bice, Sydney", 
    "Chick, Michael", 
    "Chilakapati, Karthik", 
    "Collier IV, Kelley", 
    "Cordovado, Alex", 
    "Cross, Kyler-Adam", 
    "DeBord, Wyatt", 
    "Dean, Iliyah", 
    "Denson, Lewis", 
    "Emoghene, Okeoghene Ari", 
    "Ehrenhalt, Amanda", 
    "Escarment, Christian", 
    "Fang, Jeffrey", 
    "Ferrier, Joshua", 
    "Foster, Rodes", 
    "Gong, Samantha", 
    "Gold, Colin", 
    "Guzman, Braian", 
    "Howard, Quincy", 
    "Hong, Joane", 
    "Johnson, Marisa", 
    "Joseph, Miles", 
    "Karim, Jordan", 
    "Kevadia, Aayush", 
    "Kilambi, Shreya", 
    "Kopitsky, Caleb", 
    "Larach, Emiliano Gabriel", 
    "Le, Justin", 
    "Leake, Camille", 
    "Lester, Maya", 
    "Manchiraju, Michael", 
    "Malli, Anirudh", 
    "McCowin, Medina", 
    "Mehta, Priyanshu", 
    "Mehta, Romil", 
    "Mitchell, Beyonca", 
    "Molina, Sof Zambrano", 
    "Mordi, Amanda", 
    "Nadeem, Minahil", 
    "Njoku, Adaora", 
    "Nwachukwu, Obinna", 
    "Ojo, Tayo", 
    "Ozdemir, Tanju", 
    "Pajo, Kaspar", 
    "Pastula, Noah", 
    "Price, Hayes", 
    "Punati, Anish", 
    "Ravichandran, Akshar", 
    "Rege, Anaya", 
    "Richardson, Hunter", 
    "Rout, Yuv", 
    "Schwartz, Jason", 
    "Shetty, Ananya", 
    "Sharma, Divya", 
    "Smith, Velmuel", 
    "Sokoya, Okiki", 
    "Solano, Andrew", 
    "Stone, Nicholas", 
    "Taratsas, Zoe", 
    "Thompson, Chelsea", 
    "Watkins, Noelle", 
    "Werner, Abraham", 
    "Weems, Joshua", 
    "Yoon, Jeanne", 
    "Ziyad, Sultan"
];

export default predefinedNames;